(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 39212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(48989);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ AnimatePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 183 modules
var motion = __webpack_require__(12451);
;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/AnimatePage.tsx


var AnimatePage = function(param) {
    var children = param.children;
    var variants = {
        hidden: {
            opacity: 0,
            x: 0,
            y: 100
        },
        enter: {
            opacity: 1,
            x: 0,
            y: 0
        },
        exit: {
            opacity: 0,
            x: 0,
            y: -100
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: "enter",
        exit: "exit",
        variants: variants,
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/index.ts



/***/ }),

/***/ 94353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ Box; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/Box/Box.tsx

var Box = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:w-10/12 px-8 py-6 rounded-3xl glass-light dark:glass-dark mb-6 drop-shadow-lg hover:drop-shadow-2xl transition-all",
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Box/index.ts



/***/ }),

/***/ 98599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.tsx


var isLink = function(button) {
    return button.href !== undefined;
};
var Button = function(props) {
    var className = props.className, children = props.children;
    var href = isLink(props) ? props.href : undefined;
    var target = isLink(props) ? props.target : undefined;
    var download = isLink(props) ? props.download : false;
    var onClick = !isLink(props) ? props.onClick : undefined;
    var type = !isLink(props) ? props.type : undefined;
    var disabled = !isLink(props) ? props.disabled || false : undefined;
    var classes = "block gradient-border transition transition-300 rounded-md px-4 py-2 headline hover:gradient-bg hover:text-off-white";
    if (isLink(props)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            target: target,
            className: classnames_default()(classes, className),
            download: download,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        onClick: onClick,
        className: classnames_default()(classes, className),
        disabled: disabled,
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Button/index.ts



/***/ }),

/***/ 75198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/Container/Container.tsx

var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto w-full px-4 md:max-w-5xl",
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Container/index.ts



/***/ }),

/***/ 75111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ SeoHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/SeoHead.tsx


var SeoHead = function(param) {
    var title = param.title, description = param.description, _author = param.author, author = _author === void 0 ? "Chuckz Okoye" : _author, keywords = param.keywords, _image = param.image, image = _image === void 0 ? "https://res.cloudinary.com/tricelex/image/upload/v1644686428/chuckzokoye/chuckzokoye_megmrz.png" : _image, meta = param.meta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:url",
                content: "https://chuckzokoye.com/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: author
            }),
            meta && meta.length > 0 && meta.map(function(param) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: name,
                    content: content
                }, name);
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:image",
                content: image
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{"@context":"http://schema.org","@type":"WebSite","name":"chuckzokoye.com","alternateName":"Chuckz Okoye","url":"https://chuckzokoye.com/","description":"Back-End Software Engineer with a focus on Python and JavaScript. I have more than 5 years experience working in software engineering.","image":"'.concat(image, '"}')
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/index.ts



/***/ }),

/***/ 48989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/atoms/AnimatePage/index.ts + 1 modules
var AnimatePage = __webpack_require__(88678);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 1 modules
var Button = __webpack_require__(98599);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.ts + 1 modules
var Container = __webpack_require__(75198);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(72167);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/atoms/Box/index.ts + 1 modules
var Box = __webpack_require__(94353);
;// CONCATENATED MODULE: ./src/components/molecules/School/School.tsx




var School = function(param) {
    var institute = param.institute, course = param.course, date = param.date, technologies = param.technologies;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 items-center",
            children: [
                institute.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: institute.logo,
                    alt: institute.name,
                    width: 64,
                    height: 64,
                    className: "rounded-md"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-bold",
                                    children: course
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,format/* default */.Z)(new Date(date), "MMM yyyy")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: institute.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: institute.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "underlined relative",
                                children: institute.name
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: institute.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Course Contents: "
                                }),
                                technologies.join(", ")
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./src/components/molecules/School/index.ts


;// CONCATENATED MODULE: ./src/components/organisms/Education/Education.tsx



var Education = function(param) {
    var education = param.education;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: education.map(function(param, index) {
            var course = param.course, date = param.date, institute = param.institute, technologies = param.technologies;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex transition-all transform md:hover:scale-[1.01]", {
                    "justify-end": index % 2 !== 0
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(School, {
                    course: course,
                    date: date,
                    institute: institute,
                    technologies: technologies
                })
            }, course);
        })
    });
};


;// CONCATENATED MODULE: ./src/components/organisms/Education/index.ts


// EXTERNAL MODULE: ./src/components/atoms/Icon/index.ts + 8 modules
var Icon = __webpack_require__(22795);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/atoms/Podcast/Podcast.tsx


var Podcast = function(param) {
    var name = param.name, imagePath = param.imagePath, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "snap-center shrink-0 p-1 rounded-md w-[128px] h-[128px] transition-all bg-transparent hover:bg-gradient-to-r hover:from-blue-start hover:to-blue-stop dark:hover:from-purple-start dark:hover:via-purple-middle dark:hover:to-purple-stop",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imagePath,
                alt: name,
                width: 128,
                height: 128
            })
        })
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Podcast/index.ts


;// CONCATENATED MODULE: ./src/components/molecules/PodcastList/PodcastList.tsx





var PodcastList = function(param) {
    var podcasts = param.podcasts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "relative w-full flex gap-4 snap-x scroll-mandatory overflow-x-auto pb-14",
        children: podcasts.map(function(podcast) {
            return /*#__PURE__*/ (0,react.createElement)(Podcast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, podcast), {
                key: podcast.name
            }));
        })
    });
};


;// CONCATENATED MODULE: ./src/components/molecules/PodcastList/index.ts


// EXTERNAL MODULE: ./src/components/atoms/SeoHead/index.ts + 1 modules
var SeoHead = __webpack_require__(75111);
// EXTERNAL MODULE: ./node_modules/@graphcms/rich-text-react-renderer/dist/rich-text-react-renderer.esm.js + 1 modules
var rich_text_react_renderer_esm = __webpack_require__(60392);
;// CONCATENATED MODULE: ./src/components/molecules/Job/Job.tsx




var Job = function(param) {
    var company = param.company, jobTitle = param.jobTitle, fromDate = param.fromDate, toDate = param.toDate, technologies = param.technologies, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 items-start md:items-center",
                children: [
                    company.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: company.logo,
                        alt: company.name,
                        width: 64,
                        height: 64,
                        className: "rounded-md"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col-reverse md:flex-row justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold",
                                        children: jobTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm md:text-base",
                                        children: "".concat((0,format/* default */.Z)(new Date(fromDate), "MMM yyyy"), " — ").concat(toDate ? (0,format/* default */.Z)(new Date(toDate), "MMM yyyy") : "present")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: company.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: company.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "underlined relative",
                                    children: company.name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: company.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "hidden md:block text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Technologies: "
                                    }),
                                    technologies.join(", ")
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "md:hidden text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Technologies: "
                    }),
                    technologies.join(", ")
                ]
            }),
            children
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/molecules/Job/index.ts


// EXTERNAL MODULE: ./src/utils/mdxComponents.tsx
var mdxComponents = __webpack_require__(85157);
;// CONCATENATED MODULE: ./src/components/organisms/WorkExperience/WorkExperience.tsx





var WorkExperience = function(param) {
    var jobs = param.jobs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: jobs.map(function(param, index) {
            var company = param.company, jobTitle = param.jobTitle, fromDate = param.fromDate, toDate = param.toDate, technologies = param.technologies, description = param.description;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex transition-all transform md:hover:scale-[1.01]", {
                    "justify-end": index % 2 !== 0
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Job, {
                    company: company,
                    jobTitle: jobTitle,
                    fromDate: fromDate,
                    toDate: toDate,
                    technologies: technologies,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text_react_renderer_esm/* RichText */.H, {
                        renderers: mdxComponents/* mdxComponents */.d,
                        content: description
                    })
                })
            }, "".concat(company, " ").concat(jobTitle));
        })
    });
};


;// CONCATENATED MODULE: ./src/components/organisms/WorkExperience/index.ts


;// CONCATENATED MODULE: ./src/pages/about.tsx









var AboutPage = function(param) {
    var podcasts = param.podcasts, jobs = param.jobs, education = param.education;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePage/* AnimatePage */.b, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHead/* SeoHead */.f, {
                title: "About Chuckz Okoye, a FullStack Software Engineer",
                description: "As a passionate full-stack software developer, I create amazing websites and web apps to make the internet a better place."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "mt-8 text-3xl headline md:text-5xl lg:text-6xl",
                        children: "Hey, I'm Chuckz Okoye"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-2 text-xl font-bold md:text-2xl",
                        children: "FullStack Software Engineer from Nigeria"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-8",
                        children: "As a professional software developer, I create amazing scalable web applications app to make the internet a better place. I am an advocate for a decentralized internet, with major interest in the FinTech and DeFi space. Enthusiast with experience in production level technologies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "my-4",
                        children: "I am 27 years old and have been a professional web developer for about 5 years now. The technologies I work with are JavaScript, Python and Solidity with a focus on Django, React.js, Next.js, Node and Express. I use code not only to do my day-to-day job, but also to contribute to open-source projects."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "When I am not writing code I love to spend time with my family and friends in Lagos. I hang around a couple of DAOs on Discord and actively contribute to the MoonShot Collective work-stream of GitcoinDAO and I love to read fiction and non-fiction books, watch sci-fi movies and play games on my playstation console."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-12 mb-4 text-4xl headline",
                        children: "Podcasts I enjoy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PodcastList, {
                        podcasts: podcasts
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-12 mb-4 text-4xl headline",
                        children: "Experience"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkExperience, {
                        jobs: jobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-12 mb-4 text-4xl headline",
                        children: "Education"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-6",
                        children: "I am mostly self-taught, but here are some of the most relevant certifications I have achieved:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Education, {
                        education: education
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            href: "/Emmanuel_Okoye_CV.pdf",
                            download: true,
                            className: "flex gap-2 group whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-6 text-blue-500 group-hover:text-off-white dark:text-purple-500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: "DOWNLOAD"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "block headline group-hover:text-off-white",
                                    children: "Download my CV"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about = (AboutPage);


/***/ }),

/***/ 85157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ mdxComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26671);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55420);




var mdxComponents = {
    h2: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: "headline text-3xl mt-8",
            children: children
        });
    },
    h3: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: "headline text-2xl mt-8",
            children: children
        });
    },
    a: function(param) {
        var children = param.children, href = param.href;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: "_blank",
            className: "underlined relative",
            rel: "noopener noreferrer",
            children: children
        });
    },
    ul: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "list-disc ml-4 mt-4",
            children: children
        });
    },
    li: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "mt-1",
            children: children
        });
    },
    p: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "mt-4 mb-4 text-lg leading-7",
            children: children
        });
    },
    code: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            language: "typescript",
            style: react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_3__/* .dracula */ .cL,
            className: "text-sm rounded-md p-4 border border-grey-300 dark:border-grey-700 shadow-lg shadow-grey-500 dark:shadow-grey-800",
            children: children
        });
    },
    img: function(param) {
        var altText = param.altText, src = param.src;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative w-full aspect-video drop-shadow-xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src,
                alt: altText,
                layout: "fill",
                objectFit: "cover",
                className: "mt-4 mb-4"
            })
        });
    },
    bold: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
            children: children
        });
    }
};


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,3338,2167,9774,2888,179], function() { return __webpack_exec__(39212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);